// extracted by mini-css-extract-plugin
module.exports = {"root":"EditShuttleDescriptionPanel_root__34mYC","form":"EditShuttleDescriptionPanel_form__3-MSC","title":"EditShuttleDescriptionPanel_title__UVBiG"};